import { get } from '../../shared/helpers/axiosInstance';
import { CirculoCreditoValidation } from '../types/circulocredito.type';

export const getCirculoCreditoValidation = async (
	circuloCreditoId: string,
): Promise<CirculoCreditoValidation> => {
	try {
		const res = await get<CirculoCreditoValidation>(
			`/v1/circulocredito/${circuloCreditoId}`,
		);
		return res.data;
	} catch (err: any) {
		throw err.response.data.message;
	}
};
